import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APISendRecovery extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postEmail = async (email: string, language?: string): Promise<any> => {
    const query = language ? `?language=${encodeURIComponent(language)}` : "";
    let res = await this._fetch({
      url: `/users/send-recovery/${email}${query}`,
      method: "POST",
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
